import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatButtonModule } from '@angular/material/button';
import { OutlinedButtonComponent } from '@custom-components/general/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'xemex-zoom-map-dialog',
  imports: [MatIconModule, MatButtonModule, GoogleMapsModule, OutlinedButtonComponent],
  templateUrl: './zoom-map-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './zoom-map-dialog.component.scss',
})
export class ZoomMapDialogComponent {
  location: any;
  options: any;
  markerOptions: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<ZoomMapDialogComponent>,
  ) {
    this.location = data.location;
    this.options = data.options;
    this.markerOptions = data.markerOptions;
  }
}
